module.exports = __webpack_public_path__ + "static/media/canal-institucional.e3368d06.png";